import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step2Contact() {
  const {
    data,
    updateData
  } = useIntake();
  const addDecisionMaker = () => {
    const newPerson = {
      id: Date.now().toString(),
      name: '',
      role: '',
      email: '',
      phone: '',
      involvement: '',
      decisionRole: ''
    };
    updateData({
      owners: [...data.owners, newPerson]
    });
  };
  const removeDecisionMaker = (id: string) => {
    updateData({
      owners: data.owners.filter(o => o.id !== id)
    });
  };
  const updateDecisionMaker = (id: string, field: string, value: string) => {
    updateData({
      owners: data.owners.map(o => o.id === id ? {
        ...o,
        [field]: value
      } : o)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-300">
      <MascotPanel message="Laten we beginnen met uw contactgegevens. Zo weet ik precies met wie ik het genoegen heb en hoe we u het beste kunnen bereiken tijdens het project." data-id="element-301" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-302">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-303">
          Hoofdcontactpersoon
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-304">
          <Input label="Volledige naam" placeholder="Bijv. Jan Jansen" value={data.contactName} onChange={e => updateData({
          contactName: e.target.value
        })} data-id="element-305" />
          <Input label="Functie / Rol" placeholder="Bijv. Eigenaar of Marketing Manager" value={data.contactRole} onChange={e => updateData({
          contactRole: e.target.value
        })} data-id="element-306" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-307">
          <Input label="E-mailadres" type="email" placeholder="jan@bedrijf.nl" value={data.contactEmail} onChange={e => updateData({
          contactEmail: e.target.value
        })} data-id="element-308" />
          <Input label="Telefoonnummer" type="tel" placeholder="06 12345678" value={data.contactPhone} onChange={e => updateData({
          contactPhone: e.target.value
        })} data-id="element-309" />
        </div>

        <div className="space-y-6" data-id="element-310">
          <div data-id="element-311">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-312">
              Bent u de eigenaar van het bedrijf?
            </label>
            <RadioGroup columns={2} value={data.isOwner} onChange={val => updateData({
            isOwner: val
          })} options={[{
            value: 'yes',
            label: 'Ja, ik ben eigenaar'
          }, {
            value: 'no',
            label: 'Nee, ik ben medewerker/anders'
          }]} data-id="element-313" />
          </div>

          <div data-id="element-314">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-315">
              Bent u de uiteindelijke beslisser voor dit project?
            </label>
            <RadioGroup columns={2} value={data.isDecisionMaker} onChange={val => updateData({
            isDecisionMaker: val
          })} options={[{
            value: 'yes',
            label: 'Ja, ik neem de beslissingen'
          }, {
            value: 'no',
            label: 'Nee, ik overleg met anderen'
          }]} data-id="element-316" />
          </div>

          <AnimatePresence data-id="element-317">
            {data.isDecisionMaker === 'no' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden" data-id="element-318">
                <div className="pt-6 border-t border-gray-100 space-y-6" data-id="element-319">
                  <div data-id="element-320">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-321">
                      Overige beslissers / contactpersonen
                    </h3>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-322">
                      Voeg de personen toe met wie u overlegt over dit project.
                    </p>
                  </div>

                  {data.owners.map((person, index) => <motion.div key={person.id} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="p-5 bg-gray-50 rounded-2xl border border-gray-200 relative" data-id="element-323">
                      <button onClick={() => removeDecisionMaker(person.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-324">
                        <Trash2Icon className="w-4 h-4" data-id="element-325" />
                      </button>

                      <h4 className="font-semibold text-gray-900 mb-4 text-sm" data-id="element-326">
                        Contactpersoon {index + 1}
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-327">
                        <Input label="Naam" placeholder="Volledige naam" value={person.name} onChange={e => updateDecisionMaker(person.id, 'name', e.target.value)} data-id="element-328" />
                        <Input label="Functie / Rol" placeholder="Bijv. Directeur, Partner" value={person.role} onChange={e => updateDecisionMaker(person.id, 'role', e.target.value)} data-id="element-329" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-330">
                        <Input label="E-mailadres" type="email" placeholder="naam@bedrijf.nl" value={person.email} onChange={e => updateDecisionMaker(person.id, 'email', e.target.value)} data-id="element-331" />
                        <Input label="Telefoonnummer" type="tel" placeholder="06 12345678" value={person.phone} onChange={e => updateDecisionMaker(person.id, 'phone', e.target.value)} data-id="element-332" />
                      </div>
                    </motion.div>)}

                  <Button variant="outline" onClick={addDecisionMaker} className="w-full border-dashed" data-id="element-333">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-334" />
                    Contactpersoon toevoegen
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}